import { create } from 'zustand';

// Store managing global app presentation modes and configuration settings
export const useAppStore = create((set) => ({
  demoMode: false, // Default to false (Live Database/API Mode) with graceful local fallback
  setDemoMode: (value) => set({ demoMode: value }),
  isSettingsLoaded: false,
  siteSettings: {
    maintenance_mode: false,
    maintenance_image: '',
    site_logo: '',
    site_logo_dark: '',
    site_logo_light: '',
    site_favicon: '/favicon.svg',
    lead_popup_enabled: true,
    lead_popup_delay_seconds: 5
  },
  setSiteSettings: (settings) => set((state) => ({
    isSettingsLoaded: true,
    siteSettings: {
      ...state.siteSettings,
      ...settings,
      site_logo: settings?.site_logo || state.siteSettings.site_logo,
      site_logo_dark: settings?.site_logo_dark || state.siteSettings.site_logo_dark,
      site_logo_light: settings?.site_logo_light || state.siteSettings.site_logo_light,
      site_favicon: settings?.site_favicon || state.siteSettings.site_favicon,
    }
  })),
}));


